module.exports = __webpack_public_path__ + "4ea6b038cc4c8645f19db9ad5fa939ef.MP3";